import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { DriverRecordRequestService } from 'src/app/services/driverrecordrequest.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-subscribed',
    templateUrl: './subscribed.component.html',
    styleUrl: './subscribed.component.scss',
    standalone: false
})
export class SubscribedComponent {
     isSaving = false;
     public wizard!: IWizard;

     constructor (
          public _router: Router, 
          public service: DriverRecordRequestService, 
          public generalService: GeneralService) {

          
          this.wizard = this.service.getWizard();
          this.service.new();
     }

     ngOnInit(): void {
          setTimeout(() => this.scrollToTop(), 500);
     }

     finish() {
          this.scrollToTop();
          this._router.navigateByUrl('/');
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }
}


